import { CEAssignedProjectBase } from './ce-assigned-project-base'


export class CEAssignedProject extends CEAssignedProjectBase {

}